<template>
    <image-button :src="ChevronLeftMd" :hint="hint" @click="handleBack" :style="{ marginRight: marginRight }" />
</template>

<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';
import ImageButton from '@/components/ui/ImageButton.vue';
import ChevronLeftMd from '@/assets/icons/Chevron_Left_MD.svg';

defineProps({
    hint: {
        type: String,
        default: 'Назад'
    },
    marginRight: {
        type: String,
        default: '0px'
    }
});

const router = useRouter();

const handleBack = () => {
    if (window.history.length > 1) {
        router.back();
    } else {
        router.push('/');
    }
}
</script>
